<style scoped lang="scss">
.cons{
  display: none;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因调控/蛋白表达/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/产品及服务/基因调控/蛋白表达/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/蛋白表达.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">蛋白表达是指用模式生物如细菌、酵母、动物细胞或者植物细胞表达外源基因蛋白的一种分子生物学技术。在基因工程技术中占有核心地位。目前，常用的蛋白表达系统有原核生物的大肠杆菌表达系统，真核生物的酵母、昆虫杆状病毒和哺乳动物表达系统，以及无细胞表达系统等。</p>
        <p class="desc" style="font-weight:bold;margin-top: 30px;text-indent: 0em">蛋白表达系统特点</p>
        <p class="desc" >各种蛋白表达系统各有优劣，大肠杆菌和酵母表达系统蛋白表达水平高，生产成本低，但翻译后修饰能力与昆虫细胞、哺乳动物细胞存在差异。相比而言，哺乳动物表达的蛋白往往更加接近于天然蛋白，但其表达量低、实验难度高。至于无细胞表达系统的蛋白表达能力则取决于其具体的组成成分。</p>
        <p class="desc" style="font-weight:bold;margin-top: 30px;text-indent: 0em">蛋白表达系统的表达差异</p>
      </div>
      <div class="container">
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData1">
            <el-table-column
              prop="method1"
              label="系统">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="产量">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="倍增速度">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="实验难度">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="成本">
            </el-table-column>
            <el-table-column
              prop="method6"
              label="蛋白质折叠">
            </el-table-column>
            <el-table-column
              prop="method7"
              label="翻译后修饰">
            </el-table-column>
            <el-table-column
              prop="method8"
              label="毒性蛋白表达">
            </el-table-column>
          </el-table>
        </div>
        <p class="desc" style="margin-top: 30px;">a.大规模表达数毫克会非常昂贵</p>
        <p class="desc">b.无细胞蛋白表达系统的折叠和修饰能力取决于无细胞系统的物种。</p>
        <p class="desc" style="font-weight:bold;margin-top: 50px;text-indent: 0em">不同蛋白表达系统推荐</p>
        <p class="desc" style="font-weight:bold;">在选择表达系统时，需要考虑的因素包括蛋白的大小、需要蛋白的量、蛋白来源物种、以及蛋白是否有二硫键和翻译后修饰等。可以根据蛋白类型选择合适的蛋白表达系统。</p>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="蛋白类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="考虑因素">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="考虑因素">
            </el-table-column>
          </el-table>
        </div>
        <p class="desc" style="margin-top: 20px;">擎科生物依托完善的设备平台，可提供从基因合成到蛋白表达的一站式服务。我们可提供各种原始的表达菌株和克隆质粒，</p>
      </div>
      <div class="container">
        <div class="c-title">服务类型<small>Service type</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/db_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
        <ul class="effect-lists1 effect-lists">
          <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
            <img :src="`/static/img/db_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
            <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
          </li>
        </ul>
      </div>
      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因调控/蛋白表达/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.周期短——从客户提供序列、基因序列优化、载体构建、蛋白表达鉴定及纯化，最快15天闪电交付。</p>
                <p class="mb20">2.私人订制——可以根据实际需要，选用不同融合标签蛋白、不同抗性、不同作用元件的表达载体和不同性质的表达宿主。</p>
                <p class="mb20">3.低温控制——蛋白提取及纯化实验全程低温洁净环境操作，低温发货，保证蛋白品质。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData1:[
        {
          method1:'大肠杆菌',
          method2:'高',
          method3:'快/20min',
          method4:'低',
          method5:'低',
          method6:'差',
          method7:'差',
          method8:'差',
        },
        {
          method1:'昆虫',
          method2:'高',
          method3:'慢/20h',
          method4:'中等',
          method5:'高',
          method6:'较好',
          method7:'较好',
          method8:'较好',
        },
        {
          method1:'酵母',
          method2:'高',
          method3:'中等/2h',
          method4:'低',
          method5:'高',
          method6:'较好',
          method7:'较好',
          method8:'较好',
        },
        {
          method1:'哺乳动物',
          method2:'低',
          method3:'慢/20h',
          method4:'高',
          method5:'高',
          method6:'佳',
          method7:'佳',
          method8:'佳',
        },
        {
          method1:'无细胞',
          method2:'低',
          method3:'快',
          method4:'低',
          method5:'低/高ᵃ',
          method6:'-ᵇ',
          method7:'-ᵇ',
          method8:'较好',
        }
      ],
      tableData:[
        {
          method1: '胞质蛋白',
          method2: '取决于蛋白质的大小和分子内二硫键数目',
          method3: '分子量10~50kDa且含有较少二硫键的蛋白推荐大肠杆菌表达系统;更大或更多二硫键推荐杆状病毒或酵母表达系统。',
        },
        {
          method1: '分泌蛋白',
          method2: '翻译后修饰功能',
          method3: '所有表达宿主都可用于生产分泌蛋白。但由于大肠杆菌缺乏翻译后修饰功能，一般推荐酵母表达系统。',
        },
        {
          method1: '膜蛋白',
          method2: '翻译后修饰功能',
          method3: '大量表达推荐杆状病毒或酵母表达系统。',
        },
        {
          method1: '毒性蛋白',
          method2: '对宿主的毒性',
          method3: '所有表达宿主都有合适的方法用于生产毒性蛋白。',
        }
      ],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因编辑', img: '1', ref: '/products/Gene_editing'},
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        {name: '基因panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
      ],
      types1: [
        {name: '原核蛋白表达', img: '1', ref: ''},
        {name: '哺乳动物细胞蛋白表达', img: '2', ref: ''},
        {name: '酵母蛋白表达', img: '3', ref: ''},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Protein_expression.vue